<h3>กรุณายืนยันตัวตน</h3>
<p class="uk-text-center uk-text-meta">กรุณาเลือกจากเบอร์มือถือที่ท่านใช้ทำสัญญา</p>
<form autocomplete="off" #registerForm="ngForm" class="uk-margin-small-bottom uk-text-left" novalidate>
    
    <div>
        <label for="mobile" class="uk-form-label">หมายเลขโทรศัพท์มือถือ</label>
        <div class="uk-form-controls uk-position-relative">
            <input id="mobile" class="uk-input uk-border-rounded" type="text" placeholder="กรุณาระบุหมายเลขโทรศัพท์มือถือ"
                autocomplete="off" (keyup)="onKeyPress($event)" minlength="10" maxlength="10" inputmode="decimal"
                mask="0000000000" name="mobile" #mobile="ngModel" [(ngModel)]="model().form.mobile.value"
                [ngClass]="addClass(registerForm,'mobile')" [pattern]="regTel" debounce="5000" required />
            <small class="uk-text-danger uk-position-absolute uk-animation-fast uk-form-controls.error"
                tabindex="-1" [ngClass]="addClass(registerForm,'mobile','msg')">
                <span *ngIf="mobile.errors&& mobile.errors.required">กรุณาระบุหมายเลขโทรศัพท์มือถือ</span>
                <span *ngIf="mobile.errors&&mobile.errors.pattern || mobile.errors&&mobile.errors.minlength">กรุณาระบุหมายเลขโทรศัพท์มือถือให้ถูกต้อง</span>
            </small>
        </div>
    </div>
    <div class="uk-flex uk-flex-center uk-padding uk-padding-remove-horizontal">
        <button type="submit"
            class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
            [disabled]="registerForm.invalid" (click)="onSubmit()">ถัดไป
        </button>
    </div>
    <div class="uk-text-center" >
        <p class="uk-text-center uk-text-meta uk-margin-small-bottom"><small>หากท่านต้องการแก้ไขข้อมูล กรุณาติดต่อ</small></p>
        <div><a href="tel:026336060" class="uk-h5"><img src="/assets/images/icon-tel.svg" uk-svg class="tel-icon" width="15" height="15"> 0 2633 6060</a></div>    
    </div>
</form>
